import PageHead from "../Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import Image from "next/image";


import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import FooterOne from "@/components/Footer/Footer-One";

import img from "../../public/images/about/contact.jpg";
import { BaseApiService } from "@/utils/BaseApiService";
import { useState } from "react";



const ContactPage = () => {
  return (
    <>
      <PageHead title="Contact - Online Courses & Education NEXTJS14 Template" />

      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <Cart />

          <div className="rbt-conatct-area bg-gradient-11 rbt-section-gap">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title text-center mb--60">
                    <span className="subtitle bg-secondary-opacity">
                      Contact Us
                    </span>
                    <h2 className="title">
                      How can we help you?
                    </h2>
                    <h5>We are friendly and availbale to chat. Reach out to us anytime and we will happily answer your questions.</h5>
                  </div>
                </div>
              </div>
              <Contact />
            </div>
          </div>

          <ContactForm img={img} />

          <div className="rbt-google-map bg-color-white rbt-section-gapTop">
          </div>

          <FooterOne bgColor="bg-color-darker" />
        </Context>
      </Provider>
    </>
  );
};

const Contact = () => {

  const contactData = {
    "contactOne": [
      {
        "title": "Kampala, Uganda",
        "address": "Plot 4-5 Labong Road, Kololo. BMK House, Level 4. P.O Box 28136, Kampala Uganda.",
        "icon": "feather-map-pin",
      },
      {
        "title": "Nairobi, Kenya",
        "address": "12th & 13th Floor – Westpark Towers, Mpesi Lane, Off Muthithi Road, Westlands, Nairobi, Kenya. eLearning Support Office.",
        "icon": "feather-map-pin",
      },
      {
        "title": "Dar es Salaam, Tanzania",
        "address": "7th Floor Tanzanite Park New, 14107 Bagamoyo Road, Dar es Salaam, Tanzania. eLearning Support Office",
        "icon": "feather-map-pin",
      },
      {
        "title": "Juba, South Sudan",
        "address": "Coordination office: Yaro Plaza, Hope Institue of Management, Third Floor. Hai Cenima Road – Juba,South Sudan",
        "icon": "feather-map-pin",
      },
      {
        "title": "Lilongwe, Malawi",
        "address": "EBC House, Manadala Road, 1844 – Business Hub, Lilongwe Malawi. Training Coordination Office. ",
        "icon": "feather-map-pin",
      },
      {
        "title": "Lusaka, Zambia",
        "address": "1st Floor, SunShare Tower, Plot No. 15584 / 1 Katima Mulilo Road, Olympia, Lusaka, Zambia. Training Coordination Office.",
        "icon": "feather-map-pin",
      },
      {
        "title": "Accra, Ghana",
        "address": "8th Floor, One Airport Square, Airport-City-Accra, Ghana. Training Coordination and Support Office.",
        "icon": "feather-map-pin",
      },
      {
        "title": "Pretoria, South Africa",
        "address": "Walker Creek, Brooklyn Business Centre, 90 florence ribeiro avenue, muckleneuk, pretoria. Training Coordination Office.",
        "icon": "feather-map-pin",
      }
    ]
  }

  return (
    <>
      <div className="row g-5">
        {contactData &&
          contactData.contactOne.map((data, index) => (
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12 sal-animate"
              data-sal="slide-up"
              data-sal-delay="150"
              data-sal-duration="800"
              key={index}
            >
              <div className="rbt-address">
                <div className="icon">
                  <i className={data.icon}></i>
                </div>
                <div className="inner">
                  <h4 className="title">{data.title}</h4>
                  {data.address !== "" ? <p>{data.address}</p> : ""}
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

const ContactForm = ({ img, gap }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false); // State for loading indicator

  const [state, setState] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const updateState = (data) => setState((state) => ({ ...state, ...data }));

  const {
    name,
    email,
    subject,
    message
  } = state;

  const submitRequest = async (event) => {
    event.preventDefault(); // Prevent default form submission
    setErrorMessage(''); // Clear previous error messages
    setSuccessMessage(''); // Clear previous success messages

    if (!name || !email || !subject || !message) {
      setErrorMessage("Please fill in all required fields.");
      return;
    }

    setLoading(true); // Start loader

    let submitRequest = {
      fullName: name,
      emailAddress: email,
      subject,
      description: message,
      type: 'ContactUs'
    };

    try {
      const response = await new BaseApiService("/user-submissions").postRequestWithJsonResponse(submitRequest);
      if (response.status === "Success") {
        setSuccessMessage('Message submitted!');
        setState({ name: '', email: '', subject: '', message: '' });
      } else {
        setErrorMessage(response.message || "Submission failed. Please try again.");
      }
    } catch (error) {
      setErrorMessage(error.message || "An error occurred during registration.");
    } finally {
      setLoading(false); // Stop loader
    }
  };

  return (
    <>
      <div className={`rbt-contact-address ${gap}`}>
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6">
              <div className="thumbnail">
                <Image
                  className="w-100 radius-6"
                  src={img}
                  alt="Contact Images"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="rbt-contact-form contact-form-style-1 max-width-auto">
                <div className="section-title text-start">
                  <span className="subtitle bg-primary-opacity">
                    GET IN TOUCH WITH US
                  </span>
                </div>
                <h3 className="title">
                  We are ready to provide all the information you need.
                </h3>
                <form
                  id="contact-form"
                  className="rainbow-dynamic-form max-width-auto"
                  onSubmit={submitRequest}
                >
                  <div className="form-group">
                    <input
                      name="contact-name"
                      id="contact-name"
                      type="text"
                      placeholder="Name"
                      value={name}
                      onChange={(e) => updateState({ name: e.target.value })}
                    />
                    <span className="focus-border"></span>
                  </div>
                  <div className="form-group">
                    <input
                      name="contact-phone"
                      type="email"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => updateState({ email: e.target.value })}
                    />
                    <span className="focus-border"></span>
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      placeholder="Your Subject"
                      value={subject}
                      onChange={(e) => updateState({ subject: e.target.value })}
                    />
                    <span className="focus-border"></span>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="contact-message"
                      id="contact-message"
                      placeholder="Message"
                      value={message}
                      onChange={(e) => updateState({ message: e.target.value })}
                    ></textarea>
                    <span className="focus-border"></span>
                  </div>
                  {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                      {errorMessage}
                    </div>
                  )}

                  {successMessage && (
                    <div className="alert alert-success" role="alert">
                      {successMessage}
                    </div>
                  )}
                  <div className="form-submit-group">
                    <button
                      name="submit"
                      type="submit"
                      id="submit"
                      className="rbt-btn btn-md btn-gradient hover-icon-reverse w-100"
                      disabled={loading} // Disable button while loading
                    >
                      <span className="icon-reverse-wrapper">
                        <span className="btn-text">
                          {loading ? 'Submitting...' : 'Submit'}
                        </span>
                        {!loading && (
                          <>
                            <span className="btn-icon">
                              <i className="feather-arrow-right"></i>
                            </span>
                            <span className="btn-icon">
                              <i className="feather-arrow-right"></i>
                            </span>
                          </>
                        )}
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


export default ContactPage;
